import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { styles } from '../CSS/Styles'


class RiskInventory extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }


    render() {
        const { classes } = this.props;
        const headers = [['Parameter'], ['1','Very Unlikely'], ['2','Unlikely'],['3','Moderate'],['4','likely'],['5','Very likely']]
        const data = [['Probability of Occurrence 1', 
                'Event may only occur in exceptional circumstances',
                'Event is conceivable but rare or has a remote possibility of happening',
                'Event could conceivably occur',
                'Event should probably occur in most circumstances',
                'Event will occur in most circumstances'],
                ['Historical Occurrences 2',
                'No history of occurrence',
                'History of rare occurrence',
                'History of occasional occurrence',
                'History of regular occurrence',
                'History of occurrence most of the time'],
                ['Percentage Of Occurrence 3',
                '< 5% chance of occurrence',
                '5% to 25% chance of occurrence',
                '25% to 50% chance of occurrence',
                '50% to 75% chance of occurrence',
                '> 75% chance of occurrence']]

        const footNotes = ['1   Typically used for risk events that are one-off events, which may not be a common occurrence in the past (e.g. fire outbreak). When rating the probability of occurrence, ABC Group to also consider the frequency of the  underlying activities. ',
        '2   Typically applied to events that have occurred multiple times in the past (e.g. system downtime).',
        '3   In addition to these parameters, organizations in Singapore’s public and private sectors commonly include a descriptor for percentage of occurrence. ABC Group to consider adopting the additional descriptor at Group level. Typically applied to risk events with available data (e.g. talent attraction & retention). ']
        const table = (
            <Table>
                <TableHead>
                    <TableRow>
                        {headers.map((header)=>{
                            return (
                                <TableCell align='center'>
                                    {header.map((header)=>{
                                        return (
                                            <Typography className={classes.table_header} align='center'>
                                                {header}
                                            </Typography>
                                        )
                                    })}
                                </TableCell>
                            )
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((item)=>{
                        return (
                            <TableRow>
                                {item.map((data)=>{
                                    return (
                                        <TableCell>
                                            <Typography className = {classes.table_cell} align='center'>
                                                {data}
                                            </Typography>
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        )

        return (
            <div flexGrow={1}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card className={classes.card_full}>
                            <CardContent >
                                <Typography>
                                    Likelihood Impact
                                </Typography>
                                <br/>
                                {table}
                                <br/>
                                {footNotes.map((ftnote)=>{
                                    return(
                                        <Typography className = {classes.table_cell} align='left'>
                                            {ftnote}
                                        </Typography>
                                    )
                                })}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(RiskInventory);


// WEBPACK FOOTER //
// ./src/components/Risks/RiskParam.js